import { render, staticRenderFns } from "./WFieldButton.vue?vue&type=template&id=2bc428ab&"
import script from "./WFieldButton.vue?vue&type=script&lang=ts&"
export * from "./WFieldButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports